
import { Part } from '@/models/Part'

import {
	SET_TP_PARAMS,
	SET_PART_PARAMS,
	SET_MODELS,
	SET_PARTS,
	SET_MODIFICATIONS,
	SET_ENGINES,
	SET_LOCATIONS,
	SET_CURRENT_PART,
	EDIT_PART,
	REMOVE_PART,
	SET_META,
	SET_SELECTED_PARTS,
	SET_SEARCH_FILTERS,
	SET_LOADING,
	SET_LOGS,
	SET_SHOWING,
	SET_WHEEL_SPECIFICATIONS,
	SET_PARTS_STATISTICS,
	SET_PART_WHEEL_SPECIFICATIONS,
	SET_PROCESS_PICTURES_CALLBACK
} from './mutation-types'

export default {

	[SET_PROCESS_PICTURES_CALLBACK] (state, value) {
		state.picturesCallback = value
	},
	[SET_SHOWING] (state, value) {
		state.showing = value
	},
	[SET_PARTS_STATISTICS] (state, value) {
		state.partsStatistics = value
	},
	[SET_PART_WHEEL_SPECIFICATIONS] (state, value) {
		state.partWheelSpecifications = value
	},
	[SET_WHEEL_SPECIFICATIONS] (state, value) {
		state.wheelSpecifications = value
	},
	[SET_PART_PARAMS] (state, params) {
		state.partParams = params
	},
	[SET_LOADING] (state, loading) {
		state.loading = { ...state.loading, ...loading }
	},
	[SET_TP_PARAMS] (state, { departmentId, vehicleType, data }) {
		if (departmentId) {
			const cacheKey = `${departmentId}:${vehicleType}`
			state.tpParamsByDepartment = {
				...state.tpParamsByDepartment,
				[cacheKey]: data
			}
		}
		state.params = data
	},
	[SET_SEARCH_FILTERS] (state, filters) {
		state.searchFilters = filters
	},
	[SET_SELECTED_PARTS] (state, parts) {
		state.selectedParts = parts
	},
	[SET_MODELS] (state, data) {
		state.manufacturerModels = data
	},
	[SET_MODIFICATIONS] (state, data) {
		state.modelModifications = data
	},
	[SET_ENGINES] (state, data) {
		state.modificationEngines = data
	},
	[SET_LOCATIONS] (state, data) {
		state.departmentLocations = data
	},
	[SET_PARTS] (state, data) {
		if (!data || !data.length) {
			state.meta = []
		}
		state.parts = data || []
	},
	[SET_CURRENT_PART] (state, data) {
		state.currentPart = data instanceof Part ? data : new Part(data)
	},
	[EDIT_PART] (state, data) {
		state.currentPart = new Part({ ...state.currentPart, ...data })
	},
	[REMOVE_PART] (state, id) {
		state.parts = state.parts.filter(part => part.id !== id)
		if (state.meta && typeof state.meta.total === 'number') {
			state.meta = {
				...state.meta,
				total: state.meta.total - 1
			}
		}
	},
	[SET_META] (state, meta) {
		state.meta = meta
	},
	[SET_LOGS] (state, logs) {
		state.logs = logs
	}
}
